module.exports = __webpack_public_path__ + "assets/92fff502bb153168ca9154eb97f1bf49.png";